export default theme => ({
  root: {
    flexGrow: 1
  },
  lote: {
    marginBottom: 30
  }
});
